<template>
    <div class="w-100">
        <v-flex xs12 class="mb-4" v-if="actions.length">
            <draggable v-model="actions" @start="drag=true" @end="drag=false" class="draggable-row">
                <v-layout
                    class="ma-0 pa-0 mb-2"
                    v-for="(action, indexAction) in actions"
                    :key="`action${indexAction}`"
                    column
                >
                    <v-flex xs12 d-flex align-center v-if="action">
                        <div class="close-btn mr-1" style="width: 20px">
                            <div
                                v-html="require('!html-loader!@/assets/icons/draggable.svg')"
                                class="d-inline-flex size-18"
                            />
                        </div>
                        <v-flex class="d-inline-flex mr-1 main-text" style="width: 25px">
                            {{indexAction + 1}}.
                        </v-flex>
                        <v-flex class="action-row">
                            <div class="d-inline-flex" style="overflow-wrap: anywhere;" v-if="action.type == 1 && action.device">
                                {{action.device.name}} ({{ action.device.location }})
                            </div>
                            <div class="d-inline-flex" style="overflow-wrap: anywhere;" v-if="action.type == 2 && action.scenario">
                                {{action.scenario.name}} ({{ action.scenario.location }})
                            </div>
                            <div class="d-inline-flex" v-if="action.type == 3 && action.group">
                                {{action.group.name}}
                            </div>
                            <div v-if="action.type == 4" class="d-inline-flex">
                                Задержка
                            </div>
                            <div class="close-btn mx-1" style="width: 18px">
                                <div
                                    v-html="require('!html-loader!@/assets/icons/arrow_icon.svg')"
                                    class="d-inline-flex size-18"
                                />
                            </div>
                            <div v-if="action.state" class="d-inline-flex ml-1">{{action.state.name}}</div>
                            <div
                                v-else-if="
                                    action.device && action.device.device_type == 12 &&
                                     action.variable && action.variable.value_type == 'select'

                                "
                                class="d-inline-flex ml-1"
                            >
                                Выкл
                            </div>
                            <div v-if="action.number != null" class="d-inline-flex ml-1">{{action.number}}</div>
                            <div v-if="action.type == 4" class="d-inline-flex ml-1">
                                {{action.sleep}} сек.
                            </div>
                        </v-flex>
                        <div class="close-btn mx-2" @click="editAction(action)">
                            <div
                                v-html="require('!html-loader!@/assets/icons/edit_icon.svg')"
                                class="d-inline-flex size-18"
                            />
                        </div>
                        <div class="close-btn" @click="removeAction(indexAction)">
                            <div
                                v-html="require('!html-loader!@/assets/icons/close_icon.svg')"
                                class="d-inline-flex size-18"
                            />
                        </div>
                    </v-flex>
                </v-layout>
            </draggable>
        </v-flex>
        <div class="mb-2 auth-form" v-if="showActionForm">
            <v-layout row class="action-form">
                <v-flex class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-model="type"
                            placeholder="Тип действия"
                            class="dark-input dark-input-select"
                            :items="actionsValues"
                            item-text="name"
                            item-value="value"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            @change="updateType"
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item d-inline-flex align-center">
                                    <div
                                        v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                        class="d-inline-flex size-20 mr-3"
                                    />
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex class="d-inline-flex align-center">
                                    <div
                                        v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                        class="d-inline-flex size-20 mr-3"
                                    />
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                </v-flex>
                <v-flex v-if="type == 1" class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-model="device"
                            placeholder="Устройство"
                            class="dark-input dark-input-select"
                            :items="devices"
                            item-value="uid"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                            @change="updateVariable"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}} - {{item.location}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                </v-flex>
                <v-flex v-if="type == 2" class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-model="scenario"
                            placeholder="Сценарий"
                            class="dark-input dark-input-select"
                            :items="scenarios"
                            item-value="uid"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                            @change="updateVariable"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}} - {{item.location}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                </v-flex>
                <v-flex v-if="type == 3" class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-model="group"
                            placeholder="Группа сценариев"
                            class="dark-input dark-input-select"
                            :items="groups"
                            item-value="uid"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                            @change="updateVariable"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}} - {{item.location}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                </v-flex>
                <v-flex v-if="device && device.uid" class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-if="available[`device_${device.device_type}`].length"
                            v-model="variable"
                            placeholder="Вариант"
                            class="dark-input dark-input-select"
                            :items="available[`device_${device.device_type}`]"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                            :disabled="available[`device_${device.device_type}`].length == 1"
                            @change="updateState"
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item d-inline-flex align-center">
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex class="d-inline-flex align-center">
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                        <div v-else class="red-text">
                            Нет доступных действий для этого устройства
                        </div>
                    </div>
                </v-flex>
                <v-flex v-if="scenario && scenario.uid" class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-if="available.scenario.length"
                            v-model="variable"
                            placeholder="Вариант"
                            class="dark-input dark-input-select"
                            :items="available.scenario"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                            :disabled="available.scenario.length == 1"
                            @change="updateState"
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item d-inline-flex align-center">
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex class="d-inline-flex align-center">
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                        <div v-else class="red-text">
                            Нет доступных действий для сценария
                        </div>
                    </div>
                </v-flex>
                <v-flex v-if="group && group.uid" class="container-form__row">
                    <div class="auth-form__input">
                        <v-select
                            v-if="available.scenario_group"
                            v-model="variable"
                            placeholder="Вариант"
                            class="dark-input dark-input-select"
                            :items="available.scenario_group"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                            :disabled="available.scenario_group.length == 1"
                            @change="updateState"
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item d-inline-flex align-center">
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex class="d-inline-flex align-center">
                                    {{item.name}}
                                </v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                        <div v-else class="red-text">
                            Нет доступных действий для группы сценариев
                        </div>
                    </div>
                </v-flex>
                <v-flex v-if="type == 4" class="container-form__row">
                    <div class="auth-form__input">
                        <v-text-field
                            v-model="sleep"
                            placeholder="Количество сек."
                            class="dark-input error--text error-field"
                            type="number"
                            min="60"
                            :rules="rules.min"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </div>
                </v-flex>
                <div v-if="variable" class="container-form__row">
                    <div class="auth-form__input" v-if="variable.value_type == 'select'">
                        <v-select
                            v-model="state"
                            :placeholder="variable.name"
                            class="dark-input dark-input-select"
                            :items="variable.values"
                            item-text="name"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item d-inline-flex align-center">{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </div>
                    <div class="auth-form__input" v-if="variable.value_type == 'int'">
                        <v-text-field
                            v-model="number"
                            :placeholder="variable.name"
                            class="dark-input"
                            type="number"
                            min="0"
                            max="100"
                            :rules="rules.max"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </div>
                </div>
                <v-flex xs12 class="modal-row d-flex justify-center mt-1">
                    <v-flex xs6 class="modal-row d-flex justify-center mr-2">
                        <v-btn class="btn-dark main-text w-100" @click="closeAddAction">
                            Сбросить
                        </v-btn>
                    </v-flex>
                    <v-flex xs6 class="modal-row d-flex justify-center ml-2">
                        <v-btn class="btn-dark main-text w-100 ma-0" :disabled="disabledAdd" @click="addAction">
                            Сохранить
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-layout>
        </div>
        <v-flex xs12 mb-4 v-if="!showActionForm">
            <v-btn class="btn-dark main-text w-100" @click="openAddAction">
                Добавить действие +
            </v-btn>
        </v-flex>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {isNumber} from "@/utils";

export default {
    name: "ActionsForm",
    components: {draggable},
    props: {
        actionsData: {
            type: Array,
            default: () => [],
        },
        devices: {
            type: Array,
            default: () => [],
        },
        scenarios: {
            type: Array,
            default: () => [],
        },
        groups: {
            type: Array,
            default: () => [],
        },
        available: {
            type: Object,
            default: () => {},
        },
        edit: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showActionForm: false,
            type: null,
            device: null,
            scenario: null,
            group: null,
            variable: null,
            state: null,
            number: null,
            sleep: null,
            editItem: null,
            actionsValues: [
                {
                    name: "Устройство",
                    value: 1,
                    icon: "device",
                },
                {
                    name: "Сценарий",
                    value: 2,
                    icon: "scenario",
                },
                {
                    name: "Группа сценариев",
                    value: 3,
                    icon: "group_scenario",
                },
                {
                    name: "Задержка",
                    value: 4,
                    icon: "timeout",
                },
            ],
            actions: [],
            rules: {
                min: [value => !!value && value > 59 || 'Минимальное значение 60 сек.'],
                max: [v => !!v && v < 101 || "Максимальное значение 100"],
            },
        };
    },
    computed: {
        disabledAdd() {
            return !this.type ||
                (this.type == 1 && !this.device) ||
                (this.type == 2 && !this.scenario) ||
                (this.type == 3 && !this.group) ||
                (this.type == 4 && !this.sleep) ||
                (this.type != 4 && !this.variable) ||
                (this.variable && this.variable.value_type == 'select' && !this.state) ||
                (this.variable && this.variable.value_type == 'int' && (!this.number || this.number > 100));
        },
    },
    watch: {
        edit(val) {
            if (val) {
                this.setActionsEdit();
            }
        },
        device(val) {
            if (val) {
                if (this.available[`device_${val.device_type}`].length == 1) {
                    this.variable = this.available[`device_${val.device_type}`][0];
                }
            }
        },
        group(val) {
            if (val && this.available.scenario_group.length == 1) {
                this.variable = this.available.scenario_group.scenario[0];
            }
        },
        scenario(val) {
            if (val && this.available.scenario.length == 1) {
                this.variable = this.available.scenario[0];
            }
        },
    },
    methods: {
        setActionsEdit() {
            this.actions = [];
            this.edit.forEach((el) => {
                let action = {};
                if (el.device) {
                    action.device = el.device;
                    action.type = 1;
                    let device_type = action.device ? action.device.device_type : "";
                    let availArr = this.available[`device_${device_type}`];
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            return _.has(el.state, avail.key);
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.scenario) {
                    action.scenario = el.scenario;
                    action.type = 2;
                    let availArr = this.available.scenario;
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            return _.has(el.state, avail.key);
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.scenario_group) {
                    action.group = el.scenario_group;
                    action.type = 3;
                    let availArr = this.available.scenario_group;
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            return _.has(el.state, avail.key);
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.sleep) {
                    action.sleep = el.sleep;
                    action.type = 4;
                }
                this.actions.push(action);
            });
            this.actions = _.orderBy(this.actions, ["index"]);
            this.$emit('update:actionsData', this.actions);
        },
        openAddAction() {
            this.showActionForm = true;
        },
        closeAddAction() {
            this.showActionForm = false;
            this.editItem = null;
            this.type = null;
            this.updateType();
        },
        addAction() {
            let action = {};
            if (this.type) {
                action.type = this.type;
            }
            if (this.device || this.scenario || this.group) {
                if (this.device) {
                    action.device = this.device;
                }
                if (this.scenario) {
                    action.scenario = this.scenario;
                }
                if (this.group) {
                    action.group = this.group;
                }
                action.variable = this.variable;
                if (this.state || (this.device && this.variable.value_type == 'select' && this.device.device_type == 12)) {
                    action.state = this.state;
                }
                if (this.number) {
                    action.number = this.number;
                }
            }
            if (this.sleep) {
                action.sleep = this.sleep;
            }
            if (this.editItem) {
                let equal = null;
                this.actions.forEach((el, index) => {
                    if (_.isEqual(this.editItem, el)) {
                        equal = index;
                    }
                });
                if (equal != null) {
                    this.actions[equal] = action;
                } else {
                    this.actions.push(action);
                }
            } else {
                this.actions.push(action);
            }
            this.editItem = null;
            this.$emit('update:actionsData', this.actions);
            this.closeAddAction();
        },
        removeAction(item) {
            this.actions.splice(item, 1);
            this.$emit('update:actionsData', this.actions);
        },
        editAction(item) {
            this.editItem = JSON.parse(JSON.stringify(item));
            if (this.editItem.type) {
                this.type = this.editItem.type;
            }
            if (this.editItem.device || this.editItem.scenario || this.editItem.group) {
                if (this.editItem.device) {
                    this.device = this.editItem.device;
                }
                if (this.editItem.scenario) {
                    this.scenario = this.editItem.scenario;
                }
                if (this.editItem.group) {
                    this.group = this.editItem.group;
                }
                this.variable = this.editItem.variable;
                if (
                    this.editItem.state ||
                    (this.editItem.device && this.editItem.variable.value_type == 'select' && this.editItem.device.device_type == 12)
                ) {
                    this.state = this.editItem.state;
                }
                if (this.editItem.number) {
                    this.number = this.editItem.number;
                }
            }
            if (this.editItem.sleep) {
                this.sleep = this.editItem.sleep;
            }
            this.openAddAction();
        },
        updateState() {
            this.state = null;
            this.number = null;
        },
        updateVariable() {
            this.variable = null;
            this.updateState();
        },
        updateType() {
            this.device = null;
            this.scenario = null;
            this.group = null;
            this.sleep = null;
            this.updateVariable();
        },
        checkNumber(evt) {
            return isNumber(evt);
        },
        update() {
            this.$emit('update:actionsData', this.actions);
        },
    }
}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}

.action-form {
    width: 100%;
    margin: 0 0 8px 0;
    gap: 14px;
}

.action-row {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 6px 0;
    color: var(--rh-main-color);
    border-radius: 30px;
    min-height: 39px;
    font-size: 16px;
    line-height: 19px;
    align-self: center;
    align-items: center;
    width: calc(100% - 100px);

    &:hover {
        cursor: pointer;
    }
}

.draggable-row {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
}

.v-input.input-form-grey {
    &::v-deep .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot {
                height: 40px;
            }
        }

        .v-text-field__details {
            top: 12px;
            position: relative;
        }
    }

    &.error-field {
        &::v-deep .v-input__control {
            .v-text-field__details {
                top: 12px;
                position: relative;
            }
        }
    }
}
</style>